<div class="input-with-icon" style="width: 100%;">
    <i class="material-icons input-icon">search</i>
    <input class="form-control" type="text" (input)="onSearchChange()" [placeholder]="labelSearch" style="width: 50%;"/>
</div>